import FuseScrollbars from '@fuse/core/FuseScrollbars';
import FuseUtils from '@fuse/utils';
import _ from '@lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { handleRequestSort, handleClick, handleChangePage, handleChangeRowsPerPage } from 'app/main/utils/tableUtils';
import { selectTitleCompanies, getTitleCompanies } from '../store/titleCompaniesSlice';
import TitleCompaniesTableHead from './TitleCompaniesTableHead';

function TitleCompaniesTable(props) {
  const dispatch = useDispatch();
  const titleCompanies = useSelector(selectTitleCompanies);
  const searchText = '';

  const [data, setData] = useState(titleCompanies);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState({
    direction: 'asc',
    id: null
  });

  useEffect(() => {
    dispatch(getTitleCompanies());
  }, [dispatch]);

  useEffect(() => {
    if (searchText.length !== 0) {
      setData(FuseUtils.filterArrayByString(titleCompanies, searchText));
      setPage(0);
    } else {
      setData(titleCompanies);
    }
  }, [titleCompanies, searchText]);

  return (
    <div className="w-full flex flex-col">
      <FuseScrollbars className="flex-grow overflow-x-auto">
        <Table stickyHeader className="min-w-xl" aria-labelledby="tableTitle">
          <TitleCompaniesTableHead
            order={order}
            onRequestSort={handleRequestSort(order, setOrder)}
            rowCount={data.length}
          />

          <TableBody>
            {_.orderBy(
              data,
              [
                o => {
                  switch (order.id) {
                    case 'name': {
                      return o.name;
                    }
                    default: {
                      return o[order.id];
                    }
                  }
                }
              ],
              [order.direction]
            )
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(n => {
                return (
                  <TableRow
                    className="h-64 cursor-pointer"
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={n.id}
                    onClick={() => handleClick(props, '/data-directory/title-company')(n)}
                  >
                    <TableCell className="p-4 md:p-16" component="th" scope="row">
                      {n.name}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </FuseScrollbars>

      <TablePagination
        className="flex-shrink-0 border-t-1"
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'Previous Page'
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page'
        }}
        onChangePage={handleChangePage(setPage)}
        onChangeRowsPerPage={handleChangeRowsPerPage(setRowsPerPage)}
      />
    </div>
  );
}

export default withRouter(TitleCompaniesTable);
